var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessFavourite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.1945L18.326 10.4997L14.4944 0.5L10.6629 10.4997L0.5 11.1945L8.29483 18.0701L5.73698 28.5L14.4944 22.7495L23.2519 28.5L20.6941 18.0701L28.5 11.1945Z",
    fill: "#0D0D0D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.1945L18.326 10.4997L14.4944 0.5L10.6629 10.4997L0.5 11.1945L8.29483 18.0701L5.73698 28.5L14.4944 22.7495L23.2519 28.5L20.6941 18.0701L28.5 11.1945Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.1945L18.326 10.4997L14.4944 0.5L10.6629 10.4997L0.5 11.1945L8.29483 18.0701L5.73698 28.5L14.4944 22.7495L23.2519 28.5L20.6941 18.0701L28.5 11.1945Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.1945L18.326 10.4997L14.4944 0.5L10.6629 10.4997L0.5 11.1945L8.29483 18.0701L5.73698 28.5L14.4944 22.7495L23.2519 28.5L20.6941 18.0701L28.5 11.1945Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.1945L18.326 10.4997L14.4944 0.5L10.6629 10.4997L0.5 11.1945L8.29483 18.0701L5.73698 28.5L14.4944 22.7495L23.2519 28.5L20.6941 18.0701L28.5 11.1945Z",
    fill: "black",
    fillOpacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 11.1945L18.326 10.4997L14.4944 0.5L10.6629 10.4997L0.5 11.1945L8.29483 18.0701L5.73698 28.5L14.4944 22.7495L23.2519 28.5L20.6941 18.0701L28.5 11.1945Z",
    fill: "black",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessFavourite);
export default __webpack_public_path__ + "static/media/business_favourite.5f5c6e9abcd0187feec168635a1b3fed.svg";
export { ForwardRef as ReactComponent };